export default {
    data() {
        return {
            currentTag: '',
        }
    },
    methods: {
        updateCurrentTag(tag) {
            this.currentTag = tag;
        }
    },
};